var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('ReportsDetailMobile',{attrs:{"pid":_vm.pid}}),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.close}},[_vm._v("Close")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }